// TODO: this function must be removed from anywhere and deleted after backend model will be filled with this fields.
export function fixBlockedItemMessage(message) {
    if (message.blockedItem.warehouseman === undefined)
        message.blockedItem.warehouseman = null;
    if (message.blockedItem.trackableStatus === undefined)
        message.blockedItem.trackableStatus = 0;
}
